import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { StoreScrollLink } from '@/store/components/StoreScrollLink'
import {
  STORE_EXPLORE_LINKS,
  isStoreExploreLinkActive,
} from '@/store/lib/storeExploreLinks'
import { cn } from '@/lib/utils'

export function StoreMobileExploreMenu() {
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)
  const { pathname, search } = useLocation()

  useEffect(() => {
    setOpen(false)
  }, [pathname, search])

  useEffect(() => {
    if (!open) return

    const onPointerDown = (event: MouseEvent | TouchEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', onPointerDown)
    document.addEventListener('touchstart', onPointerDown)
    return () => {
      document.removeEventListener('mousedown', onPointerDown)
      document.removeEventListener('touchstart', onPointerDown)
    }
  }, [open])

  return (
    <div ref={rootRef} className="store-mobile-explore-menu relative shrink-0">
      <button
        type="button"
        className="store-mobile-explore-menu-btn focus-ring"
        aria-label={open ? 'Close explore menu' : 'Open explore menu'}
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen((value) => !value)}
      >
        {open ? (
          <X className="h-5 w-5" aria-hidden />
        ) : (
          <Menu className="h-5 w-5" aria-hidden />
        )}
      </button>

      {open && (
        <div
          className="store-mobile-explore-panel"
          role="menu"
          aria-label="Explore"
        >
          {STORE_EXPLORE_LINKS.map(({ to, label }) => {
            const active = isStoreExploreLinkActive(to, pathname, search)
            return (
              <StoreScrollLink
                key={to}
                to={to}
                role="menuitem"
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'store-mobile-explore-link focus-ring',
                  active && 'store-mobile-explore-link--active'
                )}
                onClick={() => setOpen(false)}
              >
                {label}
              </StoreScrollLink>
            )
          })}
        </div>
      )}
    </div>
  )
}
